import { useEffect } from "react";
import "../../styles/website/Home.css";
import "../../styles/website/AboutUs.css";
import "../../styles/website/Earn.css";
import "../../styles/website/Pricing.css";
import Layout from "../website/component/Layout.jsx";

/* ---------- آیکون‌های خطی جایگزین ایموجی ---------- */
function IconGrowth() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path
        d="M3 17l6-6 4 4 8-8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 6h6v6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconBrand() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path
        d="M11.6 3.4l7 7c.5.5.5 1.4 0 1.9l-6.3 6.3c-.5.5-1.4.5-1.9 0l-7-7c-.3-.3-.4-.6-.4-1V4.4c0-.6.4-1 1-1h6.6c.4 0 .7.1 1 .4z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="1.4" />
    </svg>
  );
}

function IconCoin() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <circle cx="12" cy="12" r="8.5" />
      <path
        d="M12 7.8v8.4M14.6 9.6c0-1-.9-1.8-2.6-1.8-1.7 0-2.6.8-2.6 1.8 0 2.4 5.2 1 5.2 3.4 0 1-.9 1.8-2.6 1.8-1.7 0-2.6-.8-2.6-1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconBolt() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path
        d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const whyItems = [
  {
    icon: <IconGrowth />,
    title: "چند برابر مشتری",
    text: "با فروشگاه آنلاین، مشتریان از سراسر ایران می‌توانند ۲۴ ساعته از شما خرید کنند — نه فقط همسایه‌های محله.",
  },
  {
    icon: <IconBrand />,
    title: "برندینگ واقعی",
    text: "فروشگاه حرفه‌ای، اعتماد مشتری را چند برابر می‌کند و فروش را بالا می‌برد.",
  },
  {
    icon: <IconCoin />,
    title: "از ماهی ۸۰۰ هزار تومان",
    text: "کمتر از هزینه یک تبلیغ محلی. با همین مبلغ یک کانال فروش دائمی برای کسب‌وکارتان می‌سازید.",
  },
  {
    icon: <IconBolt />,
    title: "بازگشت سرمایه سریع",
    text: "حتی یک فروش اضافه در روز، هزینه ماهانه را جبران می‌کند. مابقی سود خالص شماست.",
  },
];

const features = [
  "فروشگاه اختصاصی",
  "بدون محدودیت تعداد محصول",
  "بدون محدودیت تعداد مشتری",
  "بدون محدودیت سفارش و دسته‌بندی",
  "مطابق با استانداردهای ایران",
  "آموزش رایگان",
  "پشتیبانی رایگان",
  "کمک در راه‌اندازی",
  "ارسال پیامک هنگام ثبت سفارش",
  "بی‌نهایت فروشگاه برای هر کاربر",
];

const plans = [
  {
    key: "yearly",
    featured: true,
    badge: "پیشنهاد ویژه (اقتصادی‌ترین)",
    name: "پلن ۱ ساله",
    monthly: "۱۰,۹۴۵,۰۰۰ تومان",
    savings: "صرفه‌جویی ۳۳٪ نسبت به پلن ۳ ماهه",
    breakdown: [
      { label: "  ", value: " " },
      { label: "راه اندازی اولیه", value: "رایگان" },
      { label: "آموزش و پشتیبانی", value: "رایگان" },
    ],
    total: " ",
  },
  {
    key: "half-yearly",
    featured: false,
    name: "پلن ۶ ماهه",
    monthly: "۶,۸۲۰,۰۰۰ تومان",
    savings: "صرفه‌جویی ۱۶٪ نسبت به پلن ۳ ماهه",
    breakdown: [
      { label: "  ", value: " " },
      { label: "راه اندازی اولیه", value: "رایگان" },
      { label: "آموزش و پشتیبانی", value: "رایگان" },
    ],
    total: "۶,۸۲۰,۰۰۰ تومان",
  },
  {
    key: "quarterly",
    featured: false,
    name: "پلن ۳ ماهه",
    monthly: "۳,۹۹۳,۰۰۰ تومان",
    savings: null,
    breakdown: [
      { label: "  ", value: " " },
      { label: "راه اندازی اولیه", value: "رایگان" },
      { label: "آموزش و پشتیبانی", value: "رایگان" },
    ],
    total: "۳,۹۹۳,۰۰۰ تومان",
  },
];

function CheckIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
    >
      <path
        d="M5 12.5l4.5 4.5L19 7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Pricing() {
  // اسکرول‌ریویل — دقیقا هم‌الگو با Home.jsx (document.querySelectorAll، نه ref)
  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const targets = document.querySelectorAll(".plan-card, .reveal");

    let observer;
    if ("IntersectionObserver" in window && !reduceMotion) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in-view");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 },
      );
      targets.forEach((el) => observer.observe(el));
    } else {
      targets.forEach((el) => el.classList.add("in-view"));
    }

    return () => observer && observer.disconnect();
  }, []);

  return (
    <Layout>
      {/* ---------- Hero: ساده، تک‌ستونه، بدون عنصر بصری متحرک ---------- */}
      <section className="pricing-hero">
        <div className="wrap pricing-hero-inner">
          <h1>پلن مناسب خود را انتخاب کنید</h1>
          <p className="pricing-hero-sub">
            هر کاربر می‌تواند بی‌نهایت فروشگاه داشته باشد. تمام پلن‌ها شامل تمام
            امکانات هستند.
          </p>
        </div>
      </section>

      {/* ---------- چرا این قیمت واقعاً ارزان است ---------- */}
      <section className="pricing-why">
        <div className="wrap">
          <div className="section-head reveal">
            <h2>چرا این قیمت واقعاً ارزان است؟</h2>
          </div>
          <div className="pricing-why-grid">
            {whyItems.map((item) => (
              <div className="tile-dark why-tile" key={item.title}>
                <div className="why-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- پلن‌ها ---------- */}
      <section className="plans">
        <div className="wrap plans-grid">
          {plans.map((plan) => (
            <div
              key={plan.key}
              className={
                "plan-card" +
                (plan.featured ? " plan-card-featured tile-dark" : " tile")
              }
            >
              {plan.badge && <span className="plan-badge">{plan.badge}</span>}

              <span className="plan-name">{plan.name}</span>

              <div className="plan-price-row">
                <span className="plan-price-num">{plan.monthly}</span>
                {/* <span className="plan-price-unit">تومان / ماهیانه</span> */}
              </div>

              {plan.savings && (
                <span className="plan-savings">{plan.savings}</span>
              )}

              <div className="plan-breakdown">
                {plan.breakdown.map((row) => (
                  <div className="plan-breakdown-row" key={row.label}>
                    <span>{row.label}</span>
                    <b>{row.value}</b>
                  </div>
                ))}
                {/* <div className="plan-breakdown-row plan-breakdown-total">
                  <span>جمع کل</span>
                  <b>{plan.total}</b>
                </div> */}
              </div>

              <ul className="plan-features">
                {features.map((f) => (
                  <li key={f}>
                    <CheckIcon />
                    {f}
                  </li>
                ))}
              </ul>

              <a href="/panel/login">
                <button
                  type="button"
                  className={
                    "btn " + (plan.featured ? "btn-primary" : "btn-ghost")
                  }
                >
                  شروع راه‌اندازی
                </button>
              </a>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
